import { render, staticRenderFns } from "./cultural-creation.vue?vue&type=template&id=d2c18152&scoped=true"
import script from "./cultural-creation.vue?vue&type=script&lang=js"
export * from "./cultural-creation.vue?vue&type=script&lang=js"
import style0 from "./cultural-creation.vue?vue&type=style&index=0&id=d2c18152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c18152",
  null
  
)

export default component.exports